document.addEventListener('DOMContentLoaded', function () {
  function showRegisterSuccessStep() {
    const registerPage = document.querySelector('.customer.register[data-register-success-enabled="true"]');
    const formStep = document.getElementById('register-form-step');
    const successStep = document.getElementById('register-success-step');
    if (!registerPage || !formStep || !successStep) return false;

    formStep.hidden = true;
    successStep.hidden = false;
    return true;
  }

  function shouldShowRegisterSuccessStep() {
    const params = new URLSearchParams(window.location.search);
    return params.has('account_created') || sessionStorage.getItem('registerAccountCreated') === '1';
  }

  if (shouldShowRegisterSuccessStep()) {
    showRegisterSuccessStep();
  }

  function setPasswordVisibility(field, visible) {
    const input = field.querySelector('input');
    const button = field.querySelector('[data-password-toggle]');
    if (!input || !button) return;

    const showText = button.querySelector('[data-show-text]');
    const hideText = button.querySelector('[data-hide-text]');

    input.type = visible ? 'text' : 'password';
    showText.classList.toggle('hidden', visible);
    hideText.classList.toggle('hidden', !visible);
    button.setAttribute('aria-label', visible ? hideText.textContent : showText.textContent);
  }

  document.querySelectorAll('[data-password-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      const field = button.closest('.field--password');
      if (!field) return;

      const input = field.querySelector('input');
      setPasswordVisibility(field, input.type === 'password');
    });
  });

  const authWrapper = document.querySelector('[data-password-visible-by-default]');
  if (authWrapper && authWrapper.dataset.passwordVisibleByDefault === 'true') {
    authWrapper.querySelectorAll('.field--password').forEach(function (field) {
      setPasswordVisibility(field, true);
    });
  }

  const registerForm = document.querySelector('.customer.register form');
  if (registerForm) {
    const passwordInput = registerForm.querySelector('#RegisterForm-password');
    const confirmInput = registerForm.querySelector('#RegisterForm-password-confirm');
    const mismatchError = registerForm.querySelector('#RegisterForm-password-mismatch');

    function passwordsMatch() {
      if (!passwordInput || !confirmInput) return true;
      return passwordInput.value.trim() === confirmInput.value.trim();
    }

    function setMismatchState(hasMismatch) {
      if (!confirmInput || !mismatchError) return;

      if (hasMismatch) {
        confirmInput.setAttribute('aria-invalid', 'true');
        confirmInput.setAttribute('aria-describedby', 'RegisterForm-password-mismatch');
        mismatchError.hidden = false;
        return;
      }

      confirmInput.removeAttribute('aria-invalid');
      confirmInput.removeAttribute('aria-describedby');
      mismatchError.hidden = true;
    }

    function validatePasswords() {
      if (!confirmInput || !confirmInput.value) {
        setMismatchState(false);
        return true;
      }

      const matches = passwordsMatch();
      setMismatchState(!matches);
      return matches;
    }

    registerForm.addEventListener('submit', function (event) {
      if (!passwordInput || !confirmInput) return;

      if (!validatePasswords()) {
        event.preventDefault();
        confirmInput.focus();
        return;
      }

      sessionStorage.setItem('registerAccountCreated', '1');
    });

    [passwordInput, confirmInput].forEach(function (input) {
      if (!input) return;

      input.addEventListener('input', validatePasswords);
    });
  }
});
